import React from 'react';
import { connect } from 'react-redux';
import { showNotification } from 'ra-core';
import { Button as MuiButton } from '@material-ui/core';
import CustomActiveField from '../common/CustomActiveField';
import { API_BASE } from '../dataProvider';

const ActiveFieldWithToggle = ({ record, dispatch }) => {
    const handleToggle = async (e) => {
        e.stopPropagation(); // Prevent row click event
        
        if (!record || !record.id) {
            dispatch(showNotification('Invalid record', 'warning'));
            return;
        }

        const newActiveStatus = !record.active;
        
        try {
            const token = localStorage.getItem('BITFA:DASHBOARD:AUTH:TOKEN');
            const response = await fetch(`${API_BASE}/accounts/${record.id}/update_active_status`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    active: newActiveStatus
                })
            });

            if (response.ok) {
                dispatch(showNotification(
                    `Account active status updated to ${newActiveStatus ? 'Active' : 'Inactive'}`,
                    'info'
                ));
                // Refresh the page to update the list
                window.location.reload();
            } else {
                const errorData = await response.json().catch(() => ({}));
                const errorMessage = errorData.message || 'Failed to update active status';
                dispatch(showNotification(errorMessage, 'warning'));
            }
        } catch (error) {
            console.error('Error updating active status:', error);
            dispatch(showNotification('Failed to update active status. Please try again.', 'warning'));
        }
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <CustomActiveField record={record} source="active" />
            <MuiButton
                variant="contained"
                color="primary"
                size="small"
                onClick={handleToggle}
                style={{
                    minWidth: 'auto',
                    padding: '4px 12px',
                    fontSize: '12px',
                    textTransform: 'none',
                    backgroundColor: record.active ? '#f44336' : '#4caf50',
                    color: 'white'
                }}
            >
                {record.active ? 'Deactivate' : 'Activate'}
            </MuiButton>
        </div>
    );
};

export default connect()(ActiveFieldWithToggle);
